import { render, staticRenderFns } from "./ViqTimelineEvent.vue?vue&type=template&id=63b1f1f2&scoped=true"
import script from "./ViqTimelineEvent.vue?vue&type=script&lang=js"
export * from "./ViqTimelineEvent.vue?vue&type=script&lang=js"
import style0 from "./ViqTimelineEvent.vue?vue&type=style&index=0&id=63b1f1f2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1f1f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b1f1f2')) {
      api.createRecord('63b1f1f2', component.options)
    } else {
      api.reload('63b1f1f2', component.options)
    }
    module.hot.accept("./ViqTimelineEvent.vue?vue&type=template&id=63b1f1f2&scoped=true", function () {
      api.rerender('63b1f1f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqTimelineEvent.vue"
export default component.exports